<div class="title">
  <span>{{ 'realtime:wallboardAgentColumn_AgentStatus' | i18next }}</span>
</div>

<div class="dialog-content">
  <table class="agent-status-table" *ngIf="items?.length; else noData">
    <thead>
      <tr>
        <th class="left">{{ 'realtime:agentstatus_name' | i18next }}</th>
        <th class="leftPadding">{{ 'realtime:agentstatus_phoneNumber' | i18next }}</th>
        <th class="leftPadding">{{ 'realtime:status' | i18next }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let el of items" [style.background-color]="el.color || null">
        <td class="left">
          {{ fullName(el) }}
        </td>
        <td class="leftPadding">
          {{ el.formattedPhoneNumber || '' }}
        </td>
        <td class="leftPadding status-cell">
          <img
            *ngIf="el.statusIcon"
            [src]="el.statusIcon"
            [alt]="translateStatus(el.formattedStatus)"
            class="status-icon"
          />
          <span>{{ translateStatus(el.formattedStatus) }}</span>
        </td>
      </tr>
    </tbody>
  </table>

  <ng-template #noData>
    <div class="no-items">—</div>
  </ng-template>
</div>

<mat-dialog-actions>
  <button id="close-btn-agents-status-dialog" mat-stroked-button [ngClass]="['secondary-button']" (click)="closeDialog()">
    {{ 'translation:Close' | i18next }}
  </button>
</mat-dialog-actions>
